import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import { TreeActions as Documentation } from "./TreeActions";
import Registries from "./Registries";

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function ChapterTabs({
  currentNode,
  setCurrentNode,
  chapterTreeId,
  handleModification
}) {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };
  return(
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          aria-label="chapter tabs"
        >
          <Tab label="Documentación" {...a11yProps(0)} />
          <Tab disabled={!currentNode.registries} label="Registros" {...a11yProps(1)} />
        </Tabs>
        <CustomTabPanel value={tabValue} index={0}>
          <Documentation
            key={currentNode.id}
            currentNode={currentNode}
            setCurrentNode={setCurrentNode}
            chapterTreeId={chapterTreeId}
            handleModification={handleModification}
          />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
            <Registries
              key={currentNode.id}
              registries={currentNode.registries}
              setCurrentNode={setCurrentNode}
              currentNode={currentNode}
              handleModification={handleModification}
            />
        </CustomTabPanel>
      </Box>
  );
}
